import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fas);


const Div = styled.footer`

    color: white;

    a {
        color: white;
        text-decoration: none;
    }

    a:hover {
        color: white;
        text-decoration: none;
    }


    /* =========================
       FOOTER PRINCIPAL
    ========================= */

    .footer-main {
        background: #0074af;
        padding: 55px 7% 40px;
    }


    .footer-grid {
        display: grid;
        grid-template-columns: 1.3fr 1fr 1fr;
        gap: 60px;
        max-width: 1200px;
        margin: 0 auto;
    }


    /* =========================
       TÍTULOS
    ========================= */

    .footer-title {
        margin-bottom: 25px;

        font-size: 20px;
        font-weight: 700;
    }

    .footer-title::after {
        content: "";

        display: block;

        width: 35px;
        height: 3px;

        margin-top: 10px;

        background: #E85A20;

        border-radius: 5px;
    }


    /* =========================
       CONTACTO
    ========================= */

    .contact-item {
        display: grid;
        grid-template-columns: 35px 1fr;

        align-items: center;

        margin-bottom: 18px;
    }

    .contact-icon {
        font-size: 18px;
    }

    .contact-item p {
        margin: 0;

        font-size: 15px;
        line-height: 1.4;
    }

    .contact-label {
        display: block;

        margin-bottom: 2px;

        font-weight: 700;
    }


    /* =========================
       LINKS
    ========================= */

    .footer-links {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .footer-links a {
        font-size: 15px;

        transition: all 0.2s ease;
    }

    .footer-links a:hover {
        color: #E85A20;
        transform: translateX(4px);
    }


    /* =========================
       SINIESTROS
    ========================= */

    .footer-claims {
        max-width: 1200px;

        margin: 40px auto 0;
        padding-top: 25px;

        border-top: 1px solid rgba(255,255,255,0.2);

        text-align: center;
    }

    .footer-claims p {
        margin: 5px 0;

        font-size: 14px;
    }

    .footer-claims strong {
        color: white;
    }


    /* =========================
       INFORMACIÓN LEGAL
    ========================= */

    .footer-legal {
        background: #ffffff;

        color: #26384d;

        display: grid;
        grid-template-columns: repeat(3, 1fr);

        max-width: 1200px;

        margin: 0 auto;

        padding: 18px 30px;

        text-align: center;

        align-items: center;
    }

    .footer-legal-item {
        min-height: 45px;

        display: flex;
        flex-direction: column;
        justify-content: center;

        font-size: 12px;
        line-height: 1.3;

        padding: 0 20px;

        border-right: 1px solid #ddd;
    }

    .footer-legal-item:last-child {
        border-right: none;
    }

    .footer-legal strong {
        font-weight: 600;
    }

    .footer-legal img {
        max-height: 45px;
        max-width: 190px;
        margin: 0 auto;
    }


    /* =========================
       MOBILE
    ========================= */

    @media screen and (max-width: 768px) {

        .footer-main {
            padding: 45px 25px 35px;
        }

        .footer-grid {
            grid-template-columns: 1fr;
            gap: 35px;
        }

        .footer-title {
            margin-bottom: 18px;
        }

        .footer-claims {
            margin-top: 30px;
        }

        .footer-legal {
            grid-template-columns: 1fr;

            gap: 15px;

            padding: 20px;
        }

        .footer-legal-item {
            border-right: none;
            border-bottom: 1px solid #ddd;

            padding-bottom: 15px;
        }

        .footer-legal-item:last-child {
            border-bottom: none;
        }

    }

`;


export default function Footer() {

    return (

        <Div>

            {/* =========================
                FOOTER PRINCIPAL
            ========================= */}

            <div className="footer-main">

                <div className="footer-grid">


                    {/* CONTACTO */}

                    <div>

                        <h4 className="footer-title">
                            Información de contacto
                        </h4>


                        <div className="contact-item">

                            <div className="contact-icon">
                                <FontAwesomeIcon icon="map-marker-alt" />
                            </div>

                            <div>
                                <p className="contact-label">
                                    Dirección
                                </p>

                                <p>
                                    Riobamba 429 Piso 15<br />
                                    CABA - CP C1025ABI
                                </p>
                            </div>

                        </div>


                        <div className="contact-item">

                            <div className="contact-icon">
                                <FontAwesomeIcon icon="phone" />
                            </div>

                            <div>
                                <p className="contact-label">
                                    Teléfonos
                                </p>

                                <p>
                                    <a href="tel:08109993343">
                                        0810-999-3343
                                    </a>
                                </p>
                            </div>

                        </div>


                        <div className="contact-item">

                            <div className="contact-icon">
                                <FontAwesomeIcon icon="envelope" />
                            </div>

                            <div>
                                <p className="contact-label">
                                    Mail
                                </p>

                                <p>
                                    <a href="mailto:info@edificarseguros.com.ar">
                                        info@edificarseguros.com.ar
                                    </a>
                                </p>
                            </div>

                        </div>

                    </div>


                    {/* ACCESOS */}

                    <div>

                        <h4 className="footer-title">
                            Accesos rápidos
                        </h4>

                        <div className="footer-links">

                            <Link to="/sobre-nosotros">
                                Institucional
                            </Link>

                            <Link to="/preguntas-frecuentes">
                                Preguntas frecuentes
                            </Link>

                            <Link to="/formularios">
                                Formularios
                            </Link>

                            <Link to="/atencion-al-asegurado">
                                Atención al asegurado
                            </Link>

                            <Link to="/rrhh">
                                RRHH
                            </Link>

                             <Link to="/anulacion-poliza">
                                Formulario de arrepentimiento
                            </Link>

                          

                        </div>

                    </div>


                    {/* INFORMACIÓN */}

                    <div>

                        <h4 className="footer-title">
                            Información
                        </h4>

                        <div className="footer-links">

                            <Link to="/seguridad/lavado">
                                Prevención de lavado
                            </Link>

                            <Link to="/seguridad/fraude">
                                Lucha contra el fraude
                            </Link>

                            <Link to="/terminos-y-condiciones">
                                Términos y condiciones
                            </Link>

                            <Link to="/politica-de-privacidad">
                                Política de privacidad
                            </Link>

                        </div>

                    </div>

                </div>


                {/* SINIESTROS */}

                <div className="footer-claims">

                    <p>
                        Para envío de documentación de siniestros
                        enviar a
                    </p>

                    <p>
                        <strong>
                            <a href="mailto:recepcion@edificarseguros.com.ar">
                                recepcion@edificarseguros.com.ar
                            </a>
                        </strong>
                    </p>

                </div>

            </div>

        </Div>

    );
}



// const Div = styled.div`

//     a {
//         color: white;
//     }
//     a:hover {
//         color: white;
//     }

//     .middle p {
//         margin: 0;
//         line-height: 1.2;
//     }

//     .middle {
//         margin: 10px 0;
//         display: grid;
//         grid-template-columns: 1fr 6fr
//     }

//     .middle div:first-child {
//         text-align: center;
//     }

//     #footer {
//         background: #0074af;
//         display: grid;
//         grid-template-columns: repeat(2, 3fr);
//         grid-gap: 20px;
//         padding: 50px;
//     }

//     @media screen and (max-width: 996px) {
//         .middle {
//             display: grid;
//             grid-template-columns: 1fr;
//         }

//         #footer {
//             grid-template-columns: 1fr;
//             text-align: center;
//         }
//     }

// `

// export default function Footer() {

//     return (
//         <Div>
//             <div id="footer" className="py-5 text-light">

//                 <div>

//                     <h4>Información de contacto</h4>
//                     <div>
//                         <div className="middle">
//                             <div>
//                                 <FontAwesomeIcon icon="map-marker-alt" className="py-3 fa-3x" style={{ height: '20px' }} />
//                             </div>
//                             <div style={{ alignSelf: 'center' }}>
//                                 <p><b>Dirección</b><br /> Riobamba 429 Piso 15 CABA - CP C1025ABI</p>
//                             </div>
//                         </div>
//                         <div className="middle">
//                             <div>
//                                 <FontAwesomeIcon icon="phone" className="py-3 fa-3x" style={{ height: '20px' }} />
//                             </div>
//                             <div style={{ alignSelf: 'center' }}>
//                                 <p><b>Teléfonos</b> <br /> 0810-999-3343</p>
//                             </div>
//                         </div>
//                         <div className="middle">
//                             <div>
//                                 <FontAwesomeIcon icon="users" className="py-3 fa-3x" style={{ height: '20px' }} />
//                             </div>
//                             <div style={{ alignSelf: 'center' }}>
//                                 <p><b>Mail</b><br /> <a className="text-light" href="mailto:info@edificarseguros.com.ar">info@edificarseguros.com.ar</a> </p>
//                             </div>
//                         </div>
//                     </div>


//                 </div>
//                 <div className="px-3" style={{ alignSelf: 'center' }}>

//                     <h4><b>Sobre la compañia</b></h4>
//                     <p>Edificar Seguros está conformado por un equipo de profesionales capacitados para brindar un buen servicio en seguros.</p>

//                 </div>

//                 <div style={{ textAlign: 'center', gridColumn: '1 / span 3' }}>
//                     Para envío de documentación de siniestros enviar a <strong>recepcion@edificarseguros.com.ar</strong>
//                 </div>


//             </div>
//         </Div>
//     )

// }



